import React from 'react';
import { Col, Form } from 'react-bootstrap';
import './styles.css'

interface typeData {
  _id: string;
  name: string;
}

interface typeProps {
  title: string;
  data: typeData[];
  value: string;
  setSelected: Function;
  required?: boolean;
}

export default function Select({ title, data, value, setSelected, required }: typeProps) {

  return (
    <div className="field">
      <label htmlFor={title}>{title}:</label>

      <div className="field-inline">
        {data.sort((a: typeData, b: typeData) => a.name.localeCompare(b.name))
          .map(({ _id, name }: typeData) => {
            return (
              <label className="checkbox-item" key={_id} onClick={() => setSelected(_id)}>
                <input className="form-check-input" type="radio" name={_id + title} id={_id} value={_id || ''} checked={_id === value || false} />
                <label>{name}</label>
              </label>
            );
          })}

      </div>
    </div>
  );
}
